import React, { Component } from "react";
import { Form, Modal } from "react-bootstrap";
import Select from "react-select";
import MroService from "../../services/MroService";
import AuditService from "../../services/AuditService";
import ReactQuill from "react-quill";
import deleteicon from "../../assets/images/delete-gray.svg";
import UserService from "../../services/UserService";
import MroCategoryService from "../../services/MroCategoryService";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import Moment from "moment";
import Alerts from "../common/Alerts";
import { Link } from "react-router-dom";
import back from "./../../assets/images/back.svg";
import Collapsible from "react-collapsible";
import CustomToolbar from "../CustomToolbar";
import LinkModal from "../LinkModal";
import placeholderImage from "./../../assets/images/image-placeholder.png";
import "react-quill/dist/quill.snow.css";
import imageCompression from "browser-image-compression";
import PropertyService from "../../services/PropertyService";
import pluswIcon from "./../../assets/images/plus.svg";
import AuditTemplateService from "../../services/AuditTemplateService";

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color:
      state.isSelected && state.isFocused
        ? "white"
        : state.isSelected
        ? "black"
        : state.isFocused && "white",
    backgroundColor:
      state.isSelected && state.isFocused ? "gray" : state.isFocused && "gray",
    fontFamily: "Roboto-Regular",
    fontSize: "16px",
  }),
};
class App extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.quillRef = React.createRef();
    this.state = {
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
      errors: {},
      input: {},
      isSubmit: false,
      isLoading: false,
      showAlertModal: false,
      showConfirmModel: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      checklist_slug: this.props.match.params.checklist_slug,
      property_slug: this.props.match.params.property_slug,
      zone_type: this.props.match.params.zone_type,
      locationName: "",
      isResume: this.props.location.state?.isResume || false,
      property_inspection_perform:
      this.props.location.state?.property_name || "",
      error: "",
      showAddCategoryModal: false,
      category_name: "",
      task_name: "",
      categoryError: "",
      taskError: "",
      openCollapsibles: [],
      audit_slug:this.props.match.params.slug,
      openIndex: false,
      modalTasks: [""],
      status: Array.isArray(global.auditStatusWeb)
        ? global.auditStatusWeb
        : global.auditStatusWeb,
      steps: [
        {
          key: "firstStep",
          label: "Info",
          isDone: true,
          component: this.firstComponent,
        },
        {
          key: "secondStep",
          label: "Property Visit",
          isDone: false,
          component: this.secondComponent,
        },
        {
          key: "finalStep",
          label: "Review",
          isDone: false,
          component: this.thirdComponent,
        },
      ],
      activeStep: {
        key: "firstStep",
        label: "Info",
        isDone: true,
        component: this.firstComponent,
      },
      propertyList: [],
      zoneTypeList: [],
      is_open: 0,
      showBasicModal: false,
      isCreateMroChecked: false,
      isCreateMroCheckedBoxShow: false,
      priorityType: global.priorityType,
      selectedPriorityType: [],
      mroCategory: [],
      selectedMroCategory: [],
      userList: [],
      selectedUserList: [],
      in_time: Moment(new Date()).toDate("dd-MM-YYYY | hh:mm A"),
      out_time: "",
      is_image: false,
      login_user: global.userData.full_name,
      note: "",
      auditnote: "",
      mroCreated: false,
      isImage: false,
      arrAllImages: [],
      arrAllImages1: [],
      status_id: 1,
      deletedImages: [],
      showImportTemplateModal: false,
      templateList: [],
      selectedTemplateOption: null,
      templateError: "",
      isImportingTemplate: false,
      deleteCategoryModal: false,
      deleteCategoryIndex: null,
      deleteCategoryName: "",
      isDeleteCategory: false,
      hasImportedTemplate: false,
    };
    this.bindMethods();
    this.getPropertyList();
  }

  async getPropertyList(queryString = "") {
    this.setState({ loading: true });
    var propertyList = [];
    var propertyListData = [];
    let res = await PropertyService.getPropertyList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );

    if (global.successStatus.includes(res.status)) {
      propertyList = res.data ? res.data : [];
    }
    propertyList.forEach((item) => {
      propertyListData.push({
        label: item.property_name,
        value: item.slug,
      });
    });
    if (propertyList.length === 1) {
      this.getLocation(
        "property_slug=" + propertyList[0].slug + "&zone_type=5"
      );
      queryString =
        "property_slug=" + (propertyList[0] ? propertyList[0].slug : "");

      this.setState({
        propertyList: propertyListData,
        propertyName: propertyList[0].property_name, // Set single property name
        property_slug: propertyList[0].slug, // Set single property slug
      });
    } else {
      this.setState({
        propertyList: propertyListData,
      });
    }
    this.setState({ loading: false });
  }

  bindMethods() {
    this.closeModal = this.closeModal.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleChangeUserList = this.handleChangeUserList.bind(this);
    this.handleChangePriority = this.handleChangePriority.bind(this);
    this.handleChangeMroCategory = this.handleChangeMroCategory.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.changeHandlerForNote = this.changeHandlerForNote.bind(this);
    this.handleAnswerOptionClick = this.handleAnswerOptionClick.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.checkInspectionAvailableOnChecklistInLocal =
      this.checkInspectionAvailableOnChecklistInLocal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleModalRemove = this.handleModalRemove.bind(this);
    this.handleLink = this.handleLink.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalSubmit = this.handleModalSubmit.bind(this);
    this.imagePreview = this.imagePreview.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.openImportTemplateModal = this.openImportTemplateModal.bind(this);
    this.closeImportTemplateModal = this.closeImportTemplateModal.bind(this);
    this.handleImportTemplateChange = this.handleImportTemplateChange.bind(this);
    this.importSelectedTemplate = this.importSelectedTemplate.bind(this);
    this.showTimedAlert = this.showTimedAlert.bind(this);
    this.getImportedTemplateStorageKey =
      this.getImportedTemplateStorageKey.bind(this);
    this.markTemplateImportedForAudit =
      this.markTemplateImportedForAudit.bind(this);
    this.hasTemplateBeenImportedForAudit =
      this.hasTemplateBeenImportedForAudit.bind(this);
  }

  componentWillUnmount() {
    if (this.alertTimeout) {
      clearTimeout(this.alertTimeout);
    }
  }

  showTimedAlert(alertData, duration = 3000) {
    if (this.alertTimeout) {
      clearTimeout(this.alertTimeout);
    }

    this.setState({
      showAlertModal: true,
      ...alertData,
    });

    this.alertTimeout = setTimeout(() => {
      this.setState({ showAlertModal: false });
    }, duration);
  }

  getImportedTemplateStorageKey(auditSlug = this.state.audit_slug) {
    return auditSlug ? `hoc-imported-template-${auditSlug}` : "";
  }

  markTemplateImportedForAudit(auditSlug = this.state.audit_slug) {
    const storageKey = this.getImportedTemplateStorageKey(auditSlug);
    if (!storageKey) return;
    localStorage.setItem(storageKey, "1");
  }

  hasTemplateBeenImportedForAudit(auditSlug = this.state.audit_slug) {
    const storageKey = this.getImportedTemplateStorageKey(auditSlug);
    if (!storageKey) return false;
    return localStorage.getItem(storageKey) === "1";
  }

   async componentDidMount() {
    if (localStorage.getItem("auditCategory") == undefined) {
      this.auditHocDetail();
    } else {
      this.setState({
        category: JSON.parse(localStorage.getItem("auditCategory")),
      });
      this.setState({
        property_slug: localStorage.getItem("property_slug_audit_resume"),
        property_name: localStorage.getItem("property_name_audit_resume"),
        audit_name: localStorage.getItem("audit_name_audit_resume"),
        description: localStorage.getItem("description_audit_resume"),
      });
      setTimeout(() => {
        var queryString =
          "property_slug=" +
          (this.state.property_slug ? this.state.property_slug : "") +
          "&action_item=1";
        this.getUserList(queryString);
      }, 1000);
    }
    setTimeout(() => {
      if (this.quillRef.current) {
        const quill = this.quillRef.current.getEditor();
        if (quill) {
          quill.getModule("toolbar").addHandler("link", this.handleLink);
          // Add event listener for clicks on links
          quill.root.addEventListener("click", this.handleLinkClick);
        } else {
          console.error("Quill editor is not initialized");
        }
      } else {
        console.error("quillRef.current is null");
      }
      if (this.state.category) {
        this.setState({
          openCollapsibles: Array(this.state.category.length).fill(true), // All collapsed by default
        });
      }
    }, 100);
  
  if(Number(localStorage.getItem("activePropertyCount")) === 1 ){
    this.setState({ 
      property_slug: JSON.parse(localStorage.getItem('properties') || '[]')[0] ?.slug || '',
      property_name: JSON.parse(localStorage.getItem('properties') || '[]')[0] ?.property_name || '',
      });
    }
  } 
  componentDidUpdate(prevProps, prevState) {
    // 🔁 Detect slug change
    const prevSlug = prevProps.match?.params?.slug;
    const currentSlug = this.props.match?.params?.slug;

    if (prevSlug !== currentSlug) {
      this.auditHocDetail(currentSlug);
    
    }

    // 📝 Existing Quill logic
    if (this.quillRef.current && !prevState.note && this.state.note) {
      const quill = this.quillRef.current.getEditor();
      if (quill) {
        quill.getModule("toolbar").addHandler("link", this.handleLink);
        // Add event listener for clicks on links
        quill.root.addEventListener("click", this.handleLinkClick);
      }
    }
  }


  customValidate() {
    let isValid = true;
    return isValid;
  }
  closeModal() {
    this.setState({ showBasicModal: false });
  }

  async getLocation(queryString = "") {
    var locationList = [];
    var locationListData = [];
    let res = await MroService.getLocationsMobile(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );

    if (global.successStatus.includes(res.status)) {
      locationList = res.data ? (res.data.data ? res.data.data : res.data) : [];
    }
    // Ensure locationList is an array
    if (Array.isArray(locationList)) {
      locationList.forEach((item) => {
        locationListData.push({
          label: item.name,
          value: item.slug,
        });
      });
    } else {
      console.error("locationList is not an array:", locationList);
    }
    this.setState({ locationList: locationListData });
  }
  // Location Change Handler

  // handleChangeLocation(value) {
  //   this.setState({
  //     selecteLocationList: value,
  //     location_slug: value.value,
  //     location_name: value.label,
  //     zone_type_id: value.zone_type_id,
  //   });
  //   this.setState({ confirm_back: 1 });
  // }
  firstComponent = () => {
    //add Location in const if needed


    return (
      <div>
        <div className="row row-xs">
          {this.state.description && (
            <div>
              <label className="form-label text-left mb-0">
                Template Description
              </label>
              <p className="text-left mb-2">{this.state.description}</p>
            </div>
          )}

          <div className="col-md-12 mg-b-10">
            <h4 className="form-label text-left mg-b-0">
              {this.state.checklist_name_heading}
            </h4>
            <span className="category_name">
              <strong>{this.state.zone_name_heading}</strong>
            </span>
          </div>

          {/* Location Field */}
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label text-left mg-b-5">Title </label>
            <Form.Control
              type="text"
              onChange={this.changeHandler}
              name="title"
              value={
                this.state.title
                  ? this.state.title.replace(/<\/?[^>]+(>|$)/g, "")
                  : ""
              }
              maxLength="150"
              tabIndex="1"
              autoComplete="off"
            />
            {this.state.errors.title ? (
              <div className="text-danger">{this.state.errors.title ?? ""}</div>
            ) : (
              this.validator.message("title", this.state.title, "required", {
                className: "text-danger",
              })
            )}
          </div>
          {/* In-Time Field */}
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label text-left mg-b-5">Description (Optional) </label>
            <Form.Control
              type="text"
              onChange={this.changeHandler}
              name="auditnote"
              value={
                this.state.auditnote
                  ? this.state.auditnote.replace(/<\/?[^>]+(>|$)/g, "")
                  : ""
              }
              tabIndex="1"
              autoComplete="off"
            />
           
          </div>
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label text-left mg-b-5">Property</label>
            {this.state.slug === undefined &&
            Number(localStorage.getItem("activePropertyCount")) !== 1 ? (
              <Select
                className="multiselect new_drop"
                menuPlacement="auto"
                value={this.state.selectedPropertyList}
                options={this.state.propertyList}
                onChange={(value) => this.handleChangeProperty(value)}
                defaultValue={this.state.selectedPropertyList}
                autoComplete="off"
                getOptionValue={(option) => `${option.label}`}
                styles={customStyles}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary75: "#808080",
                    primary50: "#808080",
                    primary25: "#808080",
                  },
                })}
              />
            ) : (
              <input
                name="job_title"
                className="form-control"
                autoComplete="off"
                value={this.state.property_name}
                onChange={this.changeHandler}
                readOnly
              />
            )}
            {this.state.errors.property_slug ? (
              <div className="text-danger">
                {this.state.errors.property_slug}
              </div>
            ) : (
              this.validator.message(
                "Property",
                this.state.property_slug,
                "required",
                { className: "text-danger" }
              )
            )}
          </div>
          {/* Location if needed
           <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">Location</label>
            {isResume ? (
              <Form.Control
                readOnly
                value={location_name}
                className="form-control max_width_100"
              />
            ) : (
              <Select
                className="multiselect new_drop"
                menuPlacement="auto"
                value={this.state.selecteLocationList}
                options={this.state.locationList}
                onChange={(value) => this.handleChangeLocation(value)}
                defaultValue={this.state.selecteLocationList}
                autoComplete="off"
                getOptionValue={(option) => `${option.label}`}
                styles={customStyles}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary75: "#808080",
                    primary50: "#808080",
                    primary25: "#808080",
                  },
                })}
              />
            )}
            {!isResume && this.state.location_slug == undefined && (
              <div className="text-danger">
                {this.state.location_slug_error}
              </div>
            )}
          </div> */}

          {/* In-Time Field */}
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">In-Time</label>
           
              <DatePicker
                className="form-control max_width_100"
                showMonthDropdown
                showYearDropdown
                autoComplete="off"
                yearDropdownItemNumber={global.yearDropdownItemNumber}
                name="in_time"
                placeholderText="mm-dd-yyyy"
                dateFormat="dd MMM yyyy | hh:mm a"
                selected={this.state.in_time}
                onChange={(data) =>
                  this.changeHandler({
                    target: {
                      type: "date",
                      name: "in_time",
                      value: data,
                    },
                  })
                }
              /> 
                 {this.state.errors.in_time ? (
              <div className="text-danger">
                {this.state.errors.in_time}
              </div>
            ) : (
              this.validator.message(
                "In-Time",
                this.state.in_time,
                "required",
                { className: "text-danger" }
              )
            )}
          
          </div>

          {/* Technician Field - Always read-only */}
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">Technician</label>
            <Form.Control
              name="user_slug"
              className="form-control max_width_100"
              type="text"
              value={this.state.login_user}
              readOnly
            />
          </div>
        </div>
          <Modal show={this.state.showConfirmModel} centered>
                  <Modal.Body className="width_402 p-4 border_radius_14">
                    <div className="text-center">
                      {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
                      <h3>Resume </h3>
                      <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                        Would you like to resume or start a new?
                      </p>
                      <div className="d-flex cnt_center mt-3 row">
                        <button
                          type="button"
                          className="m-0 btn btn-outline-light btn-block"
                          onClick={() => this.resumeHandle()}
                        >
                          Resume
                        </button>
                        <button
                          type="button"
                          className="m-0 btn btn-success btn-block"
                          onClick={() => this.startNewAudit()}
                        >
                          Start New
                        </button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
      </div>
      
    );
  };

  /* *************************************** END FIRST COMPONENT ******************************* */
  // Get Checklist data

  resumeHandle = async () => {
    this.props.history.push({
      pathname: `/hoc_proprty/${this.state.audit_slug}`,
      state: {
        isResume: true,
      },
    });
     this.setState({
      showConfirmModel: false,
    });
  }
  startNewAudit = async () => {
    this.setState({ audit_slug: '' }, () => {
    this.startAudit();
  });
  }
  startAudit = async (e) => {
    localStorage.removeItem("auditCategory");

    const inputData = {
      property_slug: this.state.property_slug,
      user_slug: global.userData.slug,
      in_time: this.state.in_time,
      category: [],
      title: this.state.title,
      note: this.state.auditnote,
      out_time: null,
      is_image: false,
      status_id: 1,
    };

    try {
      const res = await AuditService.createHocAudit(inputData,this.state.audit_slug);

      if (global.successStatus.includes(res.status)) {
        const responseData = res.data?.data || {};

        this.setState((prevState) => {
          const steps = [...prevState.steps];
          const currentIndex = steps.findIndex(
            (s) => s.key === prevState.activeStep.key
          );

          return {
            audit_slug:responseData.slug ?? prevState.audit_slug,
            property_id: responseData.property_id ?? prevState.property_id,
            activeStep: steps[currentIndex + 1],
            steps,
          };
        });
      }
    } catch (error) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "Failed to start.Please try again.",
      });
    }
  };

  /* click on task checkbox */
  handleCheckboxClick(e, index, indexes) {
    // e.preventDefault();
    let CheckChecked = e.target.checked;
    let category = this.state.category;
    let currentCategory = this.state.category[index];
    let curentTask = currentCategory.tasks[indexes];
    if (CheckChecked === true) {
      currentCategory.is_selected_category = 1;
      curentTask.is_open = 1;
      curentTask.is_selected = 1;
    } else {
      currentCategory.is_selected_category = 0;
      curentTask.is_open = 0;
      curentTask.is_selected = 0;
      curentTask.task_status = null;
    }
    // this.setState({ category: category, mroCreated: isMro });
    this.setState({ category: category });
    this.localDataStorage(this.state.category);
  }
  /* YES NO NOTE ANSWER HANDLER */
  handleAnswerOptionClick(ev, index, indexes) {
    ev.preventDefault();
    let nameOfEvent = ev.target.value;
    let category = this.state.category;
    let currentCategory = this.state.category[index];
    let curentTask = currentCategory.tasks[indexes];
    const statusMap = {
      YES: 1,
      NO: 2,
      NA: 3,
    };
    if (nameOfEvent === "YES" || nameOfEvent === "NO" || nameOfEvent === "NA") {
      // Update task status based on the button clicked
      const selectedStatus = statusMap[nameOfEvent];
      if (curentTask.task_status === selectedStatus) {
        category[index].tasks[indexes].task_status = null;
        currentCategory.is_selected_category = 0;
        curentTask.is_open = 0;
        curentTask.is_selected = 0;
      } else {
        category[index].tasks[indexes].task_status = selectedStatus;
        currentCategory.task_status = selectedStatus;
        currentCategory.is_selected_category = 1;
        curentTask.is_open = 1;
        curentTask.is_selected = 1;
      }

      this.getCategoryScore(index, () => {
        const updatedCategory = this.state.category[index];
        const updatedTask = updatedCategory.tasks[indexes];

        const responseData = {
          audit_template_category_slug:
            updatedCategory.audit_template_category_slug,

          audit_cate_id: updatedCategory.audit_cate_id,
          slug: updatedCategory.slug,

          task: {
            task_id: updatedTask.slug,
            is_exclude: updatedTask.is_exclude,
            is_selected: 1,
            is_action_with_note: updatedTask.is_action_with_note,
            task_status: updatedTask.task_status,
            note_with_action_id:updatedTask.note_with_action_id,
            note: updatedTask.note,
            priority_title: updatedTask.priority_title,
            priority_type: updatedTask.priority_type,
            action_technician: updatedTask.action_technician,
            user_slug: updatedTask.user_slug,
            due_date: updatedTask.due_date,
            checked: updatedTask.checked,
            is_open: updatedTask.is_open,
          },
        };

        this.setState({ responseData, category }, () => {
          this.auditSave();
        });
      });
      return;
    }
    // Note or action item (existing code)
    if (nameOfEvent === "NOTE") {
      this.mroAndNoteDataSet(category, index, indexes);
      this.setState({
        selectedTaskId: category[index].tasks[indexes].audit_task_id,
      });
      this.setState({
        showBasicModal: true,
        index: index,
        indexes: indexes,
      });
    }
  }
  getCategoryScore = (index, callback = null) => {
    let category = this.state.category;
    var includedTotalTasks = [];
    /* calculate included task */
    category[index].is_selected_category = 1;
    category[index].audit_cate_percentage = 0.0;
    var taskList = category[index].tasks;
    for (var j in taskList) {
      if (category[index].tasks[j].is_exclude === 2) {
        includedTotalTasks = [category[index].tasks[j], ...includedTotalTasks];
      }
    }
    if (includedTotalTasks.length > 0) {
      var naCount = 0;
      var passedTask = [];
      for (var i in includedTotalTasks) {
        var taskLists = includedTotalTasks[i];
        if (taskLists.is_selected == 1 && taskLists.task_status == 1) {
          passedTask = [taskLists, ...passedTask];
        }
        if (taskLists.is_selected == 1 && taskLists.task_status == 3) {
          naCount++;
        }
      }
      const totalCounts = includedTotalTasks.length - naCount;

      var percentageWithTwoDecimalPlaces = 0.0;
      var percentage = (passedTask.length / totalCounts) * 100;
      if (percentage > 0) {
        percentageWithTwoDecimalPlaces = parseFloat(percentage).toFixed(2); //12.23
      }
      category[index].is_selected_category = 1;
      category[index].audit_cate_percentage = percentageWithTwoDecimalPlaces;
      category[index].audit_cate_task_pass = passedTask.length;
      category[index].audit_cate_task_total = totalCounts;
    } else {
      category[index].is_selected_category = 1;
      category[index].audit_cate_percentage = 100;
    }

    this.setState({ category }, () => {
      if (typeof callback === "function") {
        callback(); // ✅ Run callback after scores are set
      }
    });
  };

  handleChangeProperty(value) {
    let property_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        property_slug.push(item.value);
      });
    }
    // Zone Type Select
    let selectedZoneType = [];
    var selectedLocation = [];
    let zoneType = 5;

    global.zoneTypeList.forEach((item, i) => {
      if (parseInt(item.value) === zoneType) {
        selectedZoneType = [
          {
            value: item.value,
            label: item.label,
          },
        ];
        if (zoneType === 5) {
          // Get Equipment Zone List

          this.getLocation("property_slug=" + value.value + "&zone_type=5");
          selectedLocation = this.state.locationList;
        }
        return false;
      }
    });
    this.setState({
      selectedZoneTypeList: selectedZoneType,
      zone_type: selectedZoneType[0].value,
      selectedPropertyList: value,
      property_slug: value.value,
      property_name: value.label,
      selecteLocationList: [],
      locationList: selectedLocation,
    });
    var queryString = "property_slug=" + (value.value ? value.value : "");
    this.getUserList(queryString);
    this.setState({ confirm_back: 1 });
  }

  openAddCategoryModal = (e) => {
    if (e) e.preventDefault();
    this.setState({
      showAddCategoryModal: true,
      category_name: "",
      task_name: "",
      categoryError: "",
      taskError: "",
      modalCategory: "",
      modalTasks: [""],
      modalError: null,
    });
  };

  openAddTaskModal = (e, category) => {
    if (e) e.preventDefault();
    this.setState({
      showAddTaskModal: true,
      modalCategory: category.category_name, // for display
      modalCategoryId: category.slug, // for mapping on submit
      task_name: "",
      categoryError: "",
      taskError: "",

      modalTasks: [""],
      modalError: null,
    });
  };

  closeAddTaskModal = () => {
    this.setState({
      showAddTaskModal: false,
    });
  };
  closeAddCategoryModal = () => {
    this.setState({
      showAddCategoryModal: false,
    });
  };

  async getTemplateList(queryString = "is_dropdown=1") {
    let list = [];
    let templateList = [];
    let res = await AuditTemplateService.getAuditTemplateList(queryString);

    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data : [];
    }

    templateList = list.map((item) => ({
      label: item.audit_name,
      value: item.slug,
    }));

    this.setState({ templateList });
  }

  openImportTemplateModal = async (e) => {
    if (e) e.preventDefault();
    await this.getTemplateList();
    this.setState({
      showImportTemplateModal: true,
      selectedTemplateOption: null,
      templateError: "",
    });
  };

  closeImportTemplateModal = () => {
    this.setState({
      showImportTemplateModal: false,
      selectedTemplateOption: null,
      templateError: "",
    });
  };

  handleImportTemplateChange(value) {
    this.setState({ selectedTemplateOption: value, templateError: "" });
  }

  importSelectedTemplate = async () => {
    const { selectedTemplateOption, audit_slug } = this.state;

    if (!selectedTemplateOption?.value) {
      this.setState({ templateError: "Template is required" });
      return;
    }

    this.setState({
      isImportingTemplate: true,
      templateError: "",
    });

    try {
      let templateRes = await AuditTemplateService.getAuditTemplateRowBySlug(
        selectedTemplateOption.value
      );
      const templateData = templateRes?.data?.data || {};
      const categories = Array.isArray(templateData.category)
        ? templateData.category
        : [];

      for (const category of categories) {
        const tasks = Array.isArray(category.task_name)
          ? category.task_name
              .filter((task) => this.getPlainText(task.task_name || ""))
              .map((task) => ({
                text: task.task_name,
              }))
          : [];

        if (!category.category_name || tasks.length === 0) {
          continue;
        }

        await AuditService.createHocCatgTask(audit_slug, {
          category_name: category.category_name,
          tasks,
        });
      }

      await this.auditHocDetail();
      this.markTemplateImportedForAudit(audit_slug);
      this.setState({
        showImportTemplateModal: false,
        selectedTemplateOption: null,
        hasImportedTemplate: true,
      });
      this.showTimedAlert({
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: "Template imported successfully.",
      });
    } catch (error) {
      this.showTimedAlert({
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "Failed to import template. Please try again.",
      });
    } finally {
      this.setState({ isImportingTemplate: false });
    }
  };

  handleCategoryChange = (e) => {
    this.setState({ category_name: e.target.value });
  };

  getPlainText = (html = "") => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent.replace(/\u00A0/g, " ").trim();
  };

  submitAddCategory = async (e) => {
    if (e) e.preventDefault();

    const { modalCategory, modalTasks, audit_slug } = this.state;

    // Category validation
    if (!modalCategory || !modalCategory.trim()) {
      this.setState({ categoryError: "Category name is required" });
      return;
    }

    // Clean & validate tasks
    const validTasks = modalTasks     

    if (validTasks.length === 0) {
      this.setState({ taskError: "Task name is required" });
      return;
    }

    // Payload for API
    const inputData = {
      category_name: modalCategory.trim(),
      tasks: validTasks,
    };
    try {
      const res = await AuditService.createHocCatgTask(audit_slug, inputData);

      if (global.successStatus.includes(res.status)) {
        // Just close modal and reset fields
        this.setState({
          showAddCategoryModal: false,
          modalCategory: "",
          modalTasks: [{ text: "" }],
          categoryError: "",
          taskError: "",
        });

        if (this.state.audit_slug !== undefined) {
          // this.checklistDetail(this.state.checklist_slug);
          this.auditHocDetail(this.state.audit_slug);
        }
      }
    } catch (error) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "Failed to add category. Please try again.",
      });
    }
  };

  submitAddTask = async (e) => {
    if (e) e.preventDefault();

    const { modalCategoryId, modalTasks, audit_slug } = this.state;

    // Category validation
    if (!modalCategoryId) {
      this.setState({ categoryError: "Category  required" });
      return;
    }

    // Clean & validate tasks
    const validTasks = modalTasks
      

    if (validTasks.length === 0) {
      this.setState({ taskError: "Task name is required" });
      return;
    }

    // Payload for API
    const inputData = {
      categorySlug: modalCategoryId,
      tasks: validTasks,
    };
    try {
      const res = await AuditService.createHocTask(audit_slug, inputData);

      if (global.successStatus.includes(res.status)) {
        // Just close modal and reset fields
        this.setState({
          showAddTaskModal: false,
          modalCategoryId: "",
          modalTasks: [{ text: "" }],
          categoryError: "",
          taskError: "",
        });

        if (this.state.audit_slug !== undefined) {
          // this.checklistDetail(this.state.checklist_slug);
          this.auditHocDetail(this.state.audit_slug);
        }
      }
    } catch (error) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "Failed to add category. Please try again.",
      });
    }
  };

  auditSave = async (e) => {
    this.setState({ loading: true, isSubmit: true });
     this.setState({
      alertModalMessage: "",
    });
    let inputData = this.state.responseData;
  
    if (inputData != undefined && this.validator.allValid() && this.customValidate()) {
      let res = await AuditService.updateAuditHoc(
        this.state.audit_slug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        let responceData = res && res.data ? res.data : [];
        this.setState({
          inspectionData: responceData,
        });

        this.setState({ loading: false, isSubmit: false });
        return true;
      } else {
        let alertMessage = "";

        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.message ? res.data.message : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
        });
      }
    }
    else{

      this.validator.showMessages();
    }
  };
  /* Set mro and note data */
  mroAndNoteDataSet(category, index, indexes) {
    var selectedPriorityType = {
      label: category[index].tasks[indexes].priority_title ?? null,
      value: category[index].tasks[indexes].priority_type ?? null,
    };
    var selectedUserList = {
      label: category[index].tasks[indexes].action_technician ?? null,
      value: category[index].tasks[indexes].user_slug ?? null,
    };
    var selectedMroCategory = {
      label: category[index].tasks[indexes].mro_category ?? null,
      value: category[index].tasks[indexes].mro_category_slug ?? null,
    };
    // uncomment to use location 
    // var selecteLocationList = {
    //   label:
    //     category[index].tasks[indexes].location_name ??
    //     this.state.selecteLocationList?.label ??
    //     this.state.location_name ??
    //     "",
    //   value:
    //     category[index].tasks[indexes].location_slug ??
    //     this.state.selecteLocationList?.value ??
    //     this.state.location_slug ??
    //     "",
    // };
    var selectedZoneTypeList = {
      label: category[index].tasks[indexes].zone_type_name ?? null,
      value: category[index].tasks[indexes].zone_type ?? null,
    };
    var newDate =
      category[index].tasks[indexes].due_date != undefined
        ? Moment(category[index].tasks[indexes].due_date).toDate(
            "dd-MM-YYYY | hh:mm A"
          )
        : "";
    this.setState({
      task_name: category[index].tasks[indexes].task_name,
      task_slug: category[index].tasks[indexes].slug,
      property_name:
        this.state.property_name ?? this.state.property_inspection_perform,
      note: category[index].tasks[indexes].note,
      checked: category[index].tasks[indexes].checked,
      selectedPriorityType: selectedPriorityType,
      selectedUserList: selectedUserList,
      priority_type: category[index].tasks[indexes].priority_type,
      user_slug: category[index].tasks[indexes].user_slug,
      due_date: newDate,
      selectedMroCategory: selectedMroCategory,
      // uncomment to use location
      // selecteLocationList:
      //   selecteLocationList ?? this.state.selecteLocationList,
      selectedZoneTypeList: selectedZoneTypeList,
      arrAllImages: category[index].tasks[indexes].images,
    });
  }
  deleteImage(i) {
  const imageToDelete = this.state.arrAllImages[i];

  // Create copies of both arrays
  let arrAllImages = [...this.state.arrAllImages];
  let arrAllImages1 = [...this.state.arrAllImages1];
  let deletedImages = [...this.state.deletedImages];

  // If the image has a slug (already saved in database), add to deletedImages
  if (imageToDelete.slug) {
    deletedImages.push(imageToDelete.slug);
  }

  // Remove the image from both arrays
  arrAllImages.splice(i, 1);
  arrAllImages1.splice(i, 1);

  // Update the category state with the new images
  let category = [...this.state.category];
  category[this.state.index].tasks[this.state.indexes].images = arrAllImages;

  // Update the state with both arrays
  this.setState({
    arrAllImages,
    arrAllImages1,
    category,
    deletedImages
  });
  }

  /* handle mro and node submission */
  /* handle mro and node submission */
  submitModalforNote = async (e) => {
    e.preventDefault();
    var category = this.state.category;
    var index = this.state.index;
    var indexes = this.state.indexes;
    let currentCategory = this.state.category[index];
    let curentTask = currentCategory.tasks[indexes];

    const textOnly =
      this.state.note != undefined && this.state.note != ""
        ? this.state.note
            .replace(/<br\s*\/?>/gi, "")
            .replace(/&nbsp;/gi, " ")
            .replace(/<[^>]+>/g, "")
            .trim()
        : "";
    const cleanedValue = textOnly === "" ? "" : this.state.note;
    this.setState({ note: cleanedValue });
    curentTask.note = cleanedValue;

    const updatedArrImage1 = this.state.arrAllImages1.map((image) => ({
      ...image,
      isNew: false,
      isUploaded: true,
    }));
    if (this.state.checked === false) {
      if (this.state.note != undefined) {
        if (
          cleanedValue === "" &&
          (this.state.arrAllImages === undefined ||
            this.state.arrAllImages.length === 0)
        ) {
          category[index].tasks[indexes].is_action_with_note = 0;
          category[index].tasks[indexes].is_delete_note = 1;
          curentTask.is_action_with_note = 0;
          curentTask.is_delete_note = 1;
          this.setState({ note: null });
        } else {
          category[index].tasks[indexes].is_action_with_note = 2;
        }
        category[index].tasks[indexes].checked = false;
        currentCategory.is_selected_category = 1;
        curentTask.is_open = 1;
        curentTask.is_selected = 1;

        const responseData = {
          audit_template_category_slug:
            currentCategory.audit_template_category_slug,
          audit_cate_percentage: currentCategory.audit_cate_percentage,
          audit_cate_task_pass: currentCategory.audit_cate_task_pass,
          audit_cate_task_total: currentCategory.audit_cate_task_total,
          audit_cate_id: currentCategory.audit_cate_id,
          slug: currentCategory.slug,
          category_score: currentCategory.category_score ?? 0,
          total_actual_score: currentCategory.totalActualScore || 0,
          total_possible_score: currentCategory.totalPossibleScore || 0,
          task: {
            audit_template_task_slug: curentTask.audit_template_task_slug,
            is_exclude: curentTask.is_exclude,
            is_selected: 1,
            is_action_with_note: curentTask.is_action_with_note, // Note without action item
            task_status: curentTask.task_status,
            task_id: curentTask.slug,
            note: this.state.note,
            priority_title: null,
            priority_type: null,
            action_technician: null,
            user_slug: null,
            due_date: null,
            checked: false,
            is_open: 1,
            images: curentTask.images,
            possible_score: curentTask.possible_score ?? 0,
            task_score: curentTask.task_score ?? curentTask.actual_score ?? 0,
            deleted_images: this.state.deletedImages,
            isdeleteNote: curentTask.is_delete_note ?? 0,
          },
        }; // Log the JSON structure
        this.mroAndNoteDataSet(category, index, indexes);
        await new Promise((resolve) => {
          this.setState(
            {
              responseData: responseData,
              showBasicModal: false,
              noteMessage: "",
              deletedImages: [],
            },
            resolve
          );
        });
        this.mroAndNoteDataSet(category, index, indexes);

        // Now auditSave will have the updated state
        var resStepTwo = await this.auditSave();
        if (resStepTwo === true) {
          this.getImageForUpload();
        }

        await new Promise((resolve) => {
          this.setState({ arrAllImages1: updatedArrImage1 }, resolve);
        });
      } else {
        this.setState({
          noteMessage: "The note is required.",
          showBasicModal: true,
        });
      }
    }

    if (this.state.checked === true) {
      if (
        this.state.priority_type != undefined &&
        this.state.user_slug != undefined &&
        this.state.due_date != undefined
      ) {
        if (category[index].tasks[indexes].checked === true) {
          category[index].tasks[indexes].is_action_with_note = 1;
          category[index].tasks[indexes].checked = true;
          currentCategory.is_selected_category = 1;
          curentTask.is_open = 1;
          curentTask.is_selected = 1;
          const responseData = {
            audit_template_category_slug:
              currentCategory.audit_template_category_slug,
            audit_cate_percentage: currentCategory.audit_cate_percentage,
            audit_cate_task_pass: currentCategory.audit_cate_task_pass,
            audit_cate_task_total: currentCategory.audit_cate_task_total,
            audit_cate_id: currentCategory.audit_cate_id,
            slug: currentCategory.slug,
            category_score: currentCategory.category_score ?? 0,
            total_actual_score: currentCategory.totalActualScore || 0,
            total_possible_score: currentCategory.totalPossibleScore || 0,
            task: {
              audit_template_task_slug: curentTask.audit_template_task_slug,
              is_exclude: curentTask.is_exclude,
              is_selected: 1,
              is_action_with_note: 1,
              task_status: curentTask.task_status,
              note: this.state.note,
              task_id: curentTask.slug,
              priority_title: this.state.selectedPriorityType?.label,
              priority_type: this.state.selectedPriorityType?.value,
              action_technician: this.state.selectedUserList?.label,
              user_slug: this.state.selectedUserList?.value,
              due_date: this.state.due_date,
              checked: true,
              is_open: 1,
              images: curentTask.images,
              possible_score: curentTask.possible_score ?? 0,
              task_score: curentTask.task_score ?? curentTask.actual_score ?? 0,
              deleted_images: this.state.deletedImages,
            },
          };

          this.mroAndNoteDataSet(category, index, indexes);
          await new Promise((resolve) => {
            this.setState(
              {
                responseData: responseData,
                showBasicModal: false,
                priority_type_error: "",
                user_slug_error: "",
                due_date_error: "",
                deletedImages: [],
              },
              resolve
            );
          });
          var resStepTw = await this.auditSave();

          if (resStepTw === true) {
            this.getImageForUpload();
          }

          await new Promise((resolve) => {
            this.setState({ arrAllImages1: updatedArrImage1 }, resolve);
          });
        }
      } else {
        this.setState({
          priority_type_error: "The priority field is required.",
          user_slug_error: "The assign to field is required.",
          due_date_error: "The due date is required.",
          showBasicModal: true,
        });
      }
    }
  };
  deleteNote = async (e) => {
    const cleanedValue = "<p></p>";
    this.setState({ note: cleanedValue });
    this.deleteAllImages();
  };
  deleteAllImages() {
    // Create copies of arrays
    let arrAllImages = [...this.state.arrAllImages];
    let arrAllImages1 = [...this.state.arrAllImages1];
    let deletedImages = [...this.state.deletedImages];
    // Loop through all images
    arrAllImages.forEach((image) => {
      // If image already exists in DB, store its slug
      if (image.slug) {
        deletedImages.push(image.slug);
      } else if (image.task_slug) {
        deletedImages.push(image.task_slug);
      }
    });

    // Clear both image arrays
    arrAllImages = [];
    arrAllImages1 = [];

    // Update category state
    let category = [...this.state.category];
    category[this.state.index].tasks[this.state.indexes].images = [];

    // Update state
    this.setState({
      arrAllImages,
      arrAllImages1,
      category,
      deletedImages,
    });
  }
  // Method to send the score update
  sendScoreUpdate = async (catIdx, taskIdx) => {
    const payload = this.generateScorePayload(catIdx, taskIdx);

    this.setState(
      {
        loading: true,
        responseData: payload,
      },
      async () => {
        // This callback runs after state is updated
        try {
          const success = await this.auditSave();
          if (success) {
            this.setState({
              showAlertModal: true,
              alertModalType: "success",
              alertModalTitle: "Success",
              alertModalMessage: "Score updated successfully.",
            });
          } else {
            this.setState({
              showAlertModal: true,
              alertModalType: "error",
              alertModalTitle: "Error",
              alertModalMessage: "Failed to update score.",
            });
          }
        } catch (error) {
          console.error("Error updating score:", error);
        } finally {
          this.setState({ loading: false });
        }
      }
    );
  };

  handleLink() {
    const quill = this.quillRef.current.getEditor();
    const range = quill.getSelection();
    if (range) {
      this.setState({
        showModal: true,
        range,
        url: "",
        text: "",
        isEditing: false,
      });
    }
  }

  handleModalClose() {
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleModalSubmit(url, text) {
    const quill = this.quillRef.current.getEditor();
    const { range } = this.state;
    if (range && url && text) {
      quill.deleteText(range.index, range.length);
      quill.insertText(range.index, text, "link", url);
      quill.setSelection(range.index + text.length);
    }
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleLinkClick(event) {
    if (event.target.tagName === "A") {
      event.preventDefault();
      const quill = this.quillRef.current.getEditor();
      const range = quill.getSelection();
      const url = event.target.getAttribute("href");
      const text = event.target.innerText;

      // Prevent Quill's tooltip from showing
      quill.blur();
      this.setState({
        showModal: true,
        range: { index: range.index, length: text.length },
        url,
        text,
        isEditing: true,
      });
    }
  }

  handleModalRemove() {
    const quill = this.quillRef.current.getEditor();
    const textLength = quill.getLength();
    // let range = { index: 0, length: textLength };

    // Get the entire content and iterate over each character
    for (let i = 0; i < textLength; i++) {
      const [link] = quill.getFormat(i, 1).link || [];
      if (link) {
        // Remove the link format only, leaving the text intact
        quill.formatText(i, 1, "link", false);
      }
    }

    this.setState({ showModal: false, url: "", text: "", isEditing: false });
  }

  handleChange(value) {
    this.setState({ note: value }, () => {
      this.customValidate();
    });
  }

  /* Handle note with MRO notes */
  changeHandlerForNote = (value) => {
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].note = value;
    this.setState({ category: category, note: value });
  };

  //category and task data
  auditHocDetail = async () => {
    if (this.state.audit_slug !== undefined) {
      var resData = {};
      let res = await AuditService.getAuditHocRowBySlug(this.state.audit_slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data.data ? res.data.data : {};
        resData.in_time = resData.started_on
          ? Moment(resData.started_on).isValid()
            ? Moment(resData.started_on).toDate()
            : new Date()
          : new Date();
        resData.description = resData.audit_template
          ? resData.audit_template.description
          : "";
        resData.is_enable_weight = resData.is_enable_weight
          ? resData.is_enable_weight
          : 0;
        resData.audit_name = resData.audit_template
          ? resData.audit_template.audit_name
          : localStorage.getItem("audit_name_audit_resume");
             resData.auditnote = resData.note
          ? resData.note
          : "";        
        resData.property_slug = resData.property.slug
          ? resData.property.slug
          : "";   
        resData.selectedPropertyList = {
          'label':resData.property.property_name
          ? resData.property.property_name
          : "",
          'value':resData.property.slug
          ? resData.property.slug
          : "",
        }
        
        resData.property_name = resData.property.property_name
          ? resData.property.property_name
          : "";   
        resData.status_id = resData.audit_status ? resData.audit_status : 1;
        let taskImages = {};
        let hasImportedTemplate = this.hasTemplateBeenImportedForAudit(
          resData.slug || this.state.audit_slug
        );
        let newCategory = resData.category.map((category) => {
          category["slug"] = category.slug ? category.slug : null;
          if (category.audit_template_category_slug) {
            hasImportedTemplate = true;
          }
          category["is_selected_category"] = category.audit_category_id ? 1 : 0;
          category["audit_cate_percentage"] =
            category.audit_cate_percentage ?? 0;
          category["audit_cate_task_pass"] = category.audit_cate_task_pass ?? 0;
          category["audit_cate_task_total"] =
            category.audit_cate_task_total ?? 0;
          category["category_score"] = category.category_score ?? 0;
          category["total_possible_score"] = category.total_possible_score ?? 0;
          category["tasks"] = category.tasks.map((task) => {
            task["slug"] = task.slug ?? null;
            task["is_open"] =
              task.is_action_with_note != 0 || task.task_status != 0 ? 1 : 0;
            task["is_selected"] =
              task.is_action_with_note != 0 || task.task_status != 0 ? 1 : 0;
            task["is_action_with_note"] = task.is_action_with_note ?? 0;
            task["note_with_action_slug"] =
              task.action && task.action.slug ? task.action.slug : null;
            task["note_with_action_id"] = task.note_with_action_id ?? null;
            task["task_status"] = task.task_status
              ? parseInt(task.task_status)
              : 0;
            task["note"] =
              task.action && task.action.note ? task.action.note : null;
            task["priority_title"] =
              task.action && task.action.priority_type_name
                ? task.action.priority_type_name
                : null;
            task["priority_type"] =
              task.action && task.action.priority_type
                ? task.action.priority_type
                : null;
            task["action_technician"] =
              task.action &&
              task.action.assignee &&
              task.action.assignee.full_name
                ? task.action.assignee.full_name
                : null;
            task["user_slug"] =
              task.action && task.action.assignee && task.action.assignee.slug
                ? task.action.assignee.slug
                : null;
            task["due_date"] =
              task.action && task.action.due_date ? task.action.due_date : null;
            task["checked"] = task.is_action_with_note === 1 ? true : false;
            task["possible_score"] = task.possible_score ?? 0;
            task["task_score"] =
              task.actual_score != null &&
              task.actual_score !== undefined &&
              task.actual_score !== ""
                ? task.actual_score
                : 0;
            task["images"] =
              task.action && task.action.images ? task.action.images : [];
            if (task.audit_task_id) {
              taskImages[task.audit_task_id] = task.images;
            }
            return task;
          });
          return category;
        });
        newCategory = newCategory.filter(
          (category) => Array.isArray(category.tasks) && category.tasks.length > 0
        );
        if (hasImportedTemplate) {
          this.markTemplateImportedForAudit(resData.slug || this.state.audit_slug);
        }
        this.setState({ taskImages, hasImportedTemplate });
        // return newCategory;
        resData.category = newCategory;
      }

      const matchedStatus = global.auditStatusWeb.find(
        (item) => item.value === resData.audit_status
      );
      localStorage.setItem(
        "description_audit_resume",
        resData.description ? resData.description : ""
      );
      localStorage.setItem(
        "audit_name_audit_resume",
        resData.audit_name ? resData.audit_name : ""
      );
      this.setState({
        ...resData,
        category: resData.category || [],
        selectedStatus: matchedStatus,
        openCollapsibles: Array(resData.category?.length || 0).fill(true),
      });
      this.setState({ is_enable_weight: resData.is_enable_weight });
    }
  };

  async getImageForUpload() {
    if (this.state.backIndex === 2 && this.state.isBack === 0) {
      this.setState({ arrAllImages1: [] });
      return; // Exit early to avoid processing old images
    }
    if (this.state.isImage === true) {
      if (this.state.arrAllImages1.length > 0) {
        this.state.arrAllImages1.forEach((image, index) => {
          var categoryResultListData = this.state.inspectionData;
          if (categoryResultListData.audit_task_id == image.auditTaskId) {
            image.task_slug = categoryResultListData.audit_task_slug;
            this.onImageUpload(image);
          }
        });
      }
    }
  }
  onImageUpload = async (image) => {
    // if (image.length > 0 ) {
    if (!image.isNew || image.isUploaded) return;
    try {
      const fileData = new FormData();
      fileData.append("file_name", image.file, image.file.name);
      fileData.append("is_action_with_note", image.isActionwithNote);
      fileData.append("audit_task_slug", image.task_slug);
      fileData.append("is_completed", true);
      fileData.append("refTableId", 3);
      let res = await AuditService.uploadInspFile(fileData);
      if (global.successStatus.includes(res.status)) {
        this.setState({
          Images: res.data.fileName,
          imageUrl: res.data.filePath,
        });
        this.setState({ loading: false });
      } else if (res.status === 413) {
        this.setState({
          loading: false,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error!",
          alertModalMessage: "Content Too Large",
        });
      } else {
        let alertMessage = "";
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showSpinner: false,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
        });
      }
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } catch (error) {
      console.error("Error compressing or uploading image:", error);
      this.setState({
        loading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "An error occurred while processing the image.",
      });
    }
    // }
  };

  /* handle create mro checkbox */
  handleCheckboxChange(e) {
    let category = this.state.category;
    const checked = e.target.checked;
    /* check box checked for mro */
    if (checked === true) {
      category[this.state.index].tasks[this.state.indexes].checked = true;

      /* If action item created then call related APIs like mrocategory or technician */
      this.getMroCategoryList();
      this.getUserList();
    } else {
      category[this.state.index].tasks[this.state.indexes].checked = false;
      category[this.state.index].tasks[this.state.indexes].location_name = null;
      category[this.state.index].tasks[this.state.indexes].location_slug = null;
      category[this.state.index].tasks[this.state.indexes].mro_category = null;
      category[this.state.index].tasks[this.state.indexes].mro_category_slug =
        null;
      category[this.state.index].tasks[this.state.indexes].mro_priority = null;
      category[this.state.index].tasks[this.state.indexes].mro_priority_id =
        null;
      category[this.state.index].tasks[this.state.indexes].mro_technician =
        null;
      category[this.state.index].tasks[this.state.indexes].mro_technician_slug =
        null;
      category[this.state.index].tasks[this.state.indexes].due_date = null;
    }
    this.setState({ category: category, checked: checked });
  }
  // Get MRO Category List
  async getMroCategoryList(queryString = "") {
    var mroCategoryList = [];
    var mroCategoryListData = [];
    let res = await MroCategoryService.getMroCategoryList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      mroCategoryList = res.data ? res.data : [];
    }
    if (mroCategoryList.length > 0) {
      mroCategoryList.forEach((item) => {
        mroCategoryListData.push({
          label: item.name,
          value: item.slug,
        });
      });
    }

    this.setState({ mroCategory: mroCategoryListData });
  }
  // Get Users List
  async getUserList(queryString = "") {
    this.setState({ loading: true });
    var userList = [];
    var userListData = [];
    queryString =
      "property_slug=" +
      (this.state.property_slug ? this.state.property_slug : "");
    let res = await UserService.getUserList(
      "is_dropdown=1&is_mro=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      userList = res.data ? res.data : [];
    }

    userList.forEach((item) => {
      userListData.push({
        label: item.full_name,
        value: item.slug,
      });
    });

    this.setState({ userList: userListData });
    this.setState({ loading: false });
  }
  // MRO Category Change Handler
  handleChangeMroCategory(value) {
    let mro_category_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        mro_category_slug.push(item.value);
      });
    }
    this.setState({
      selectedMroCategory: value,
      mro_category_slug: value.value,
    });

    /* Set category data into category array */
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].mro_category =
      value.label;
    category[this.state.index].tasks[this.state.indexes].mro_category_slug =
      value.value;
    this.setState({ category: category });
    this.setState({ confirm_back: 1 });
  }
  // Priority  Change Handler
  handleChangePriority(value) {
    let priority_type = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        priority_type.push(item.value);
      });
    }
    this.setState({
      selectedPriorityType: value,
      priority_type: value.value,
      mro_priority_id: value.value,
    });
    this.setState({ confirm_back: 1 });
    /* Set category data into category array */
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].mro_priority =
      value.label;
    category[this.state.index].tasks[this.state.indexes].mro_priority_id =
      value.value;
        category[this.state.index].tasks[this.state.indexes].priority_title =
      value.label;
    category[this.state.index].tasks[this.state.indexes].priority_type =
      value.value;
    this.setState({ category: category });
  }

  // Technician/User Change Handler
  handleChangeUserList(value) {
    let user_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        user_slug.push(item.value);
      });
    }
    this.setState({
      selectedUserList: value,
      user_slug: value.value,
      mro_technician_slug: value.value,
    });
    this.setState({ confirm_back: 1 });
    /* Set category data into category array */
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].mro_technician =
      value.label;
    category[this.state.index].tasks[this.state.indexes].mro_technician_slug =
      value.value;
    category[this.state.index].tasks[this.state.indexes].zone_type =
      this.state.zone_type;
    category[this.state.index].tasks[this.state.indexes].location_slug =
      this.state.location_slug;
    category[this.state.index].tasks[this.state.indexes].location_name =
      this.state.location_name;
      category[this.state.index].tasks[this.state.indexes].action_technician =
      value.label;
    category[this.state.index].tasks[this.state.indexes].user_slug =
      value.value;
    this.setState({ category: category });
  }
  //Change handler for error and due date
  changeHandler = (event) => {
    let input = this.state.input;
    let value = event.target.value;
    input[event.target.name] = value;
    if (event.target.name == "out_time") {
      this.setState({
        [event.target.name]: Moment(value).toDate("dd-MM-YYYY | hh:mm A"),
        input: input,
      });
    } else {
      this.setState({ [event.target.name]: value, input: input });
    }
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };
  /* Handle due date for mro */
  handleDueDate = (e) => {
    let category = this.state.category;
    category[this.state.index].tasks[this.state.indexes].due_date =
      e.target.value;
    this.setState({ category: category, due_date: e.target.value });
  };
  // Add a new empty task
  addTask = () => {
    this.setState((prevState) => ({
      modalTasks: [...prevState.modalTasks, ""],
    }));
  };

  // Remove a task by index
  removeTask = (index) => {
    this.setState((prevState) => ({
      modalTasks: prevState.modalTasks.filter((_, i) => i !== index),
    }));
  };
  // Remove perfomed task
  deletetask = async(ev) => {
    // let nameOfEvent1 = ev.target.value;
    
    let delres = await AuditService.deleteAuditTask(this.state.deleteTaskSlug);
       if (global.successStatus.includes(delres.status)) {
      this.closedeletetaskModal();
      this.showTimedAlert({
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: delres.message || "Success"
      },
      () => {
        // Auto-close after 3 seconds 
        this.alertTimer = setTimeout(() => {
          this.setState({ showAlertModal: false });
        }, 3000);
      }
      );
      if (this.state.audit_slug !== undefined) {
          // this.checklistDetail(this.state.checklist_slug);
          this.auditHocDetail(this.state.audit_slug);
        }
    } else {
      this.closedeletetaskModal();
      this.showTimedAlert({
        alertModalType: "error",
        alertModalTitle: delres.data.errorCode ? delres.data.errorCode : "Error!",
        alertModalMessage: delres.data.errorMessage
          ? delres.data.errorMessage
          : delres.data.message,
      });
    }

  };

//delete task modal
opendeletetaskModal(index,indexes) {
   let currentCategory1 = this.state.category[index];
    let curentTask1 = currentCategory1.tasks[indexes];
    let deleteSlug =curentTask1.slug; 
    this.setState({ deletetaskModal: true,
      deleteTaskSlug:deleteSlug
     });
  }
closedeletetaskModal() {
    this.setState({ deletetaskModal: false });
  }
  openDeleteCategoryModal = (index) => {
    const currentCategory = this.state.category[index];
    this.setState({
      deleteCategoryModal: true,
      deleteCategoryIndex: index,
      deleteCategoryName: currentCategory?.category_name || "",
    });
  };
  closeDeleteCategoryModal = () => {
    this.setState({
      deleteCategoryModal: false,
      deleteCategoryIndex: null,
      deleteCategoryName: "",
    });
  };
  deleteCategory = async () => {
    const { category, deleteCategoryIndex } = this.state;
    const currentCategory = category?.[deleteCategoryIndex];
    const tasks = Array.isArray(currentCategory?.tasks)
      ? currentCategory.tasks
      : [];

    this.setState({ isDeleteCategory: true });

    try {
      for (const task of tasks) {
        if (task?.slug) {
          await AuditService.deleteAuditTask(task.slug);
        }
      }

      this.setState((prevState) => ({
        category: prevState.category.filter(
          (_, index) => index !== deleteCategoryIndex
        ),
        openCollapsibles: prevState.openCollapsibles.filter(
          (_, index) => index !== deleteCategoryIndex
        ),
      }));

      await this.auditHocDetail();
      this.closeDeleteCategoryModal();
      this.showTimedAlert({
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: "Category deleted successfully.",
      });
    } catch (error) {
      this.showTimedAlert({
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "Failed to delete category. Please try again.",
      });
    } finally {
      this.setState({ isDeleteCategory: false });
    }
  };
  handleToggle = (index) => {
    this.setState((prevState) => {
      const openCollapsibles = [...prevState.openCollapsibles];
      openCollapsibles[index] = !openCollapsibles[index]; // Toggle state
      return { openCollapsibles };
    });
  };
  // Update task text
  handleTaskChange = (val, index) => {
    const tasks = [...this.state.modalTasks];

    // Ensure the task at this index is an object
    if (typeof tasks[index] === "string") {
      tasks[index] = { text: val };
    } else {
      tasks[index].text = val;
    }

    this.setState({ modalTasks: tasks });
  };
  stepThreeSave = async (e) => {
    this.setState({ loading: true, isSubmit: true });
    let inputData = {
      out_time: this.state.out_time,
      status_id: this.state.status_id,
    };
    if (inputData != undefined) {
      let res = await AuditService.updateAuditV2(
        this.state.audit_slug,
        inputData
      );
      if (global.successStatus.includes(res.status)) {
        let responceData = res.data && res.data.data ? res.data.data : [];
        this.setState({
          inspectionData: responceData,
        });
        localStorage.removeItem("auditCategory");
        localStorage.removeItem("property_slug_audit_resume");
        localStorage.removeItem("property_name_audit_resume");
        localStorage.removeItem("audit_name_audit_resume");
        localStorage.removeItem("description_audit_resume");
        setTimeout(
          () => this.props.history.push("/audits"),
          global.redirect_time
        );
        this.setState({ loading: false, isSubmit: false });
      } else {
        let alertMessage = "";
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.message ? res.data.message : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
        });
      }
    }
  };

  imagePreview = async (event) => {
    this.setState({ isLoading: true });
    const files = event.target.files;
    const { category, index, indexes, arrAllImages, backIndex, isImage } =
      this.state;
    let newImage = [];
    let newImage1 = [];
    let allImages = [];

    // Validation: Check total images
    const totalImages = arrAllImages.length + files.length;
    if (totalImages > 10) {
      this.setState({
        isLoading: false,
        error: "You can only upload a maximum of 10 images.",
      });
      event.target.value = ""; // Reset the file input
      return;
    }

    if (files.length >= 1) {
      for (let i = 0; i < files.length; i++) {
        const fileSize = files[i].size;
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        if (fileSize >= 2e6) {
          // Compress the image if it's larger than 2MB
          const compressedFile = await imageCompression(files[i], options);
          allImages.push({
            file: compressedFile,
            isActionwithNote:
              category[index].tasks[indexes].is_action_with_note,
            auditTaskId: category[index].tasks[indexes].audit_task_id,
            isNew: true, // Mark as new image
            isUploaded: false,
            src: URL.createObjectURL(compressedFile),
          });
        } else {
          category[index].tasks[indexes].images = files[i];
          allImages.push({
            file: files[i],
            isActionwithNote:
              category[index].tasks[indexes].is_action_with_note,
            auditTaskId: category[index].tasks[indexes].audit_task_id,
            src: URL.createObjectURL(files[i]),
            isNew: true, // Mark as new image
            isUploaded: false,
          });
        }
      }

      if (backIndex === 2) {
        const filteredArrAllImages = this.state.arrAllImages.filter(
          (img) => img.task_slug
        );

        const filteredNewImages1 = allImages.filter((img) => !img.task_slug);

        newImage = [...filteredArrAllImages, ...filteredNewImages1];

        const filteredArrAllImages1 = this.state.arrAllImages1.filter(
          (img) => !img.task_slug
        );

        const filteredNewImages = allImages.filter((img) => !img.task_slug);

        newImage1 = [...filteredArrAllImages1, ...filteredNewImages];
      } else {
        if (isImage === true) {
          newImage = [...this.state.arrAllImages, ...allImages];
          newImage1 = [...this.state.arrAllImages1, ...allImages];
        } else {
          newImage = allImages;
          newImage1 = allImages;
        }
      }
      /* Assign single task image into the cagegory */
      category[index].tasks[indexes].images = newImage;

      // Update state with new images
      await this.setState({
        category: category,
        isImage: true,
        arrAllImages: newImage,
        arrAllImages1: newImage1,
        isLoading: false,
        error: "",
        isBack: 1,
      });
      // this.localDataStorage(this.state.category);
    } else {
      console.log("First select an image file");
      this.setState({ isLoading: false });
    }
  };
  secondComponent = () => {
    const { openCollapsibles } = this.state;
    const { error } = this.state;

    const modules = {
      toolbar: {
        container: "#toolbar",
        handlers: {
          link: this.handleLink,
        },
      },
    };

    return (
      <div className="row row-xs">
        <div className="col-md-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1">
          <label className="form-label text-left mg-b-5">
              <strong className="checklist_title d-block">Title:</strong>{" "}
              {this.state.title}
          </label>
          <label className="form-label text-left mg-b-5">
              <strong className="checklist_title d-block">Description:</strong>{" "}
              {this.state.auditnote}
          </label>
          <div className="btnNavigate d-flex justify-content-end ">
            {!this.state.isResume && !this.state.hasImportedTemplate && (
              <button
                type="button"
                className="gf-primary-btn-small-one btn btn-primary mr-2"
                onClick={(e) => this.openImportTemplateModal(e)}
              >
                Import Template
              </button>
            )}
            <button
              type="button"
              className="gf-btn-lg-stroke float-right button "
              onClick={(e) => this.openAddCategoryModal(e)}
            >
              Add Category
            </button>
          </div>
          <div className="col-md-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1">
            {/* <label className="form-label text-left mg-b-5">
              <strong className="checklist_title">Checklist:</strong>{" "}
              {this.state.auditnote}<br />
              {this.state.title}
            </label>
            <label className="form-label text-left mg-b-5">
              <strong className="checklist_title">Checklist:</strong>{" "}
              Short Description
            </label> */}
            {this.state.category !== undefined &&
              this.state.category.map((element, index) => (
                <div className="category_list_box" key={"cat_" + index}>
                  {/* Collapsible Component */}
                  <Collapsible
                    key={index}
                    trigger={
                      <div
                        className={`bedroom_title d-flex justify-content-between ${
                          openCollapsibles[index] ? "open" : ""
                        }`}
                        onClick={() => this.handleToggle(index)}
                      >
                        <span className="cate_per_title">
                          {element.category_name + " "}
                        </span>
                        <div className="d-flex align-items-center">
                          <button
                            type="button"
                            onClick={(ev) => {
                              ev.stopPropagation();
                              this.openDeleteCategoryModal(index);
                            }}
                            style={{
                              padding: "2px",
                              border: "none",
                              background: "transparent",
                              marginRight: "10px",
                            }}
                          >
                            <img
                              src={deleteicon}
                              alt="Delete category"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                            />
                          </button>
                          <span
                            className={`Collapsible-arrow ${
                              openCollapsibles[index] ? "open" : ""
                            }`}
                          >
                            <i
                              className={`fa ${
                                openCollapsibles[index]
                                  ? "fa-angle-up"
                                  : "fa-angle-down"
                              }`}
                            ></i>
                          </span>
                        </div>
                      </div>
                    }
                    open={openCollapsibles[index]} // Control collapsible state
                  >
                    {/* Task List */}
                    {element.tasks &&
                      element.tasks.map((el, indexes) => (
                        <div className="qes_ans_box" key={"task_" + indexes}>
                          <label className="check_cust">
                            <input
                              type="checkbox"
                              checked={
                                el.task_status == 1 ||
                                el.task_status == 2 ||
                                el.task_status == 3 ||
                                el.is_action_with_note == 1 ||
                                el.is_action_with_note == 2
                              }
                              name="task_status"
                            />
                            <span className="checkmark"></span>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: this.modifyTaskName(el.task_name),
                              }}
                            />
                          </label>

                          <div className="checbox_cont_div d-block">
                            <div className="d-flex" key={"ans_" + indexes}>
                              {/* Yes */}
                              <button
                                className={
                                  "gf-btn-lg-outline mr-2 " +
                                  (el.task_status == 1
                                    ? "inspect_button_yes"
                                    : "inspect_button_new")
                                }
                                onClick={(ev) => {
                                  this.handleAnswerOptionClick(
                                    ev,
                                    index,
                                    indexes
                                  );
                                }}
                                value="YES"
                              >
                                Yes
                              </button>

                              {/* No */}
                              <button
                                className={
                                  "gf-btn-lg-outline mr-2 " +
                                  (el.task_status == 2
                                    ? "inspect_button_No"
                                    : "inspect_button_new")
                                }
                                onClick={(ev) => {
                                  this.handleAnswerOptionClick(
                                    ev,
                                    index,
                                    indexes
                                  );
                                }}
                                value="NO"
                              >
                                No
                              </button>

                              {/* Note */}
                              <button
                                className={
                                  "gf-btn-lg-outline mr-2 " +
                                  (el.is_action_with_note === 1
                                    ? "inspect_button_Note"
                                    : el.is_action_with_note === 2
                                    ? "inspect_button_Action"
                                    : "inspect_button_new")
                                }
                                onClick={(ev) => {
                                  this.handleAnswerOptionClick(
                                    ev,
                                    index,
                                    indexes
                                  );
                                }}
                                value="NOTE"
                              >
                                {el.is_action_with_note === 1
                                  ? "ACTION ITEM"
                                  : el.is_action_with_note === 2
                                  ? "NOTE"
                                  : "ADD NOTE"}
                              </button>

                               <button
                              
                            type="button"
                                    onClick={() => {
                                        this.opendeletetaskModal(
                                          index,indexes
                                        );
                                      }}
                            style={{ marginLeft: "auto",
                                     padding: "2px",
                                     border: "none",
                                     background: "transparent",
                                  }}
                                > 
                            <img
                              src={deleteicon}
                              alt="Delete"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                            />
                          </button>
                            </div>
                           
                          </div>
                          
                        </div>
                      ))}
                    <div className="row m-0 pd-l-70 pd-r-0 mb-3">
                      <div className="col-md-12 pr-0">
                        <button
                          type="button"
                          className="gf-btn-lg-stroke float-right button "
                          onClick={(e) => this.openAddTaskModal(e, element)}
                        >
                          Add Task
                        </button>
                      </div>
                    </div>
                  </Collapsible>
                </div>
              ))}
          </div>
          {/*Add category and task modal*/}
          <Modal
            className="per_checklist_modal"
            dialogClassName="per_checklist_modal_dialog"
            show={this.state.showImportTemplateModal}
            centered
          >
            <Modal.Body className="width_402 p-4 border_radius_14">
              <h3 className="text-center">Import Template</h3>
              <div className="col-md-12 col-lg-12 mg-b-15">
                <label className="form-label text-left mg-b-5">Template</label>
                <Select
                  className="multiselect new_drop"
                  menuPlacement="auto"
                  value={this.state.selectedTemplateOption}
                  options={this.state.templateList}
                  isSearchable={true}
                  onChange={this.handleImportTemplateChange}
                  autoComplete="off"
                  getOptionValue={(option) => `${option.label}`}
                  styles={customStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary75: "#808080",
                      primary50: "#808080",
                      primary25: "#808080",
                    },
                  })}
                />
                {this.state.templateError && (
                  <div className="text-danger mt-1">
                    {this.state.templateError}
                  </div>
                )}
              </div>
              <div className="row mx-0">
                <div className="col-md-12 d-flex justify-content-center">
                  <button
                    type="button"
                    className="my-0 mg-l-7 btn btn-outline-light btn-block"
                    onClick={this.closeImportTemplateModal}
                    disabled={this.state.isImportingTemplate}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="m-0 btn btn-success btn-block"
                    onClick={this.importSelectedTemplate}
                    disabled={this.state.isImportingTemplate}
                  >
                    {this.state.isImportingTemplate ? global.loader : "Import"}
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <Modal className="per_checklist_modal" dialogClassName="per_checklist_modal_dialog" show={this.state.showAddCategoryModal} centered>
            <Modal.Body className="width_402 p-4 border_radius_14">
              <form onSubmit={(e) => e.preventDefault()}>
                {/* Header */}
                {/* <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-30 pd-r-20">
                  <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-0 pd-b-1 pd-r-0 pl-0">
                    <div className="az-content-label titleLable pl-0"> */}
                      <h3 className="text-center">Add Detail</h3>
                    {/* </div>
                  </div>
                </div> */}

                {/* CATEGORY */}
                {/* <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-0 w-100"> */}
                  <div className="col-md-12 col-lg-12 mg-b-15">
                    <label className="form-label text-left mg-b-5">
                      Category
                    </label>
                    <input
                      type="text"
                      className="form-control max_width_100"
                      value={this.state.modalCategory}
                      onChange={(e) =>
                        this.setState({
                          modalCategory: e.target.value,
                          categoryError: "", // clear error while typing
                        })
                      }
                    />
                    {this.state.categoryError && (
                      <div className="text-danger mt-1">
                        {this.state.categoryError}
                      </div>
                    )}
                  </div>
                {/* </div> */}

                {/* TASKS */}
                {this.state.modalTasks.map((task, index) => (
                  <div key={index} className="mb-3">
                    <div className="row mx-0">
                      {/* Task Label + Remove Button */}
                      <div
                        className="col-md-5 col-lg-8 mg-t-5 pd-l-70"
                        style={{ gap: "3px" }}
                      >
                        <label
                          className="form-label mb-0"
                          style={{ marginBottom: 0 }}
                        >
                          Task
                        </label>

                        {/* {this.state.modalTasks.length > 1 && (
                          <button
                            type="button"
                            onClick={() => this.removeTask(index)}
                            style={{
                              padding: "2px",
                              border: "none",
                              background: "transparent",
                            }}
                          >
                            <img
                              src={deleteicon}
                              alt="Delete"
                              style={{
                                width: "16px",
                                height: "16px",
                                cursor: "pointer",
                              }}
                            />
                          </button>
                        )} */}
                      </div>
                    </div>

                    {/* Quill Editor */}
                    <div className="row mx-0">
                      <div className="col-md-10 col-lg-10 mg-t-5 pd-l-70">
                        <div id={`toolbar-${index}`}>
                          <button className="ql-bold"></button>
                          <button className="ql-italic"></button>
                          <button className="ql-underline"></button>
                          <button className="ql-link"></button>
                        </div>

                        <ReactQuill
                          theme="snow"
                          value={task.text || ""}
                          onChange={(val) => this.handleTaskChange(val, index)}
                          modules={{
                            toolbar: { container: `#toolbar-${index}` },
                          }}
                          formats={global.formats}
                          className="custom_editor_style"
                        />
                      </div>
                      <div className="col-md-2 col-lg-2 ad-hoc-action-btn mg-t-5">
                        {this.state.modalTasks.length > 1 && (
                          <button
                            type="button"
                            onClick={() => this.removeTask(index)}
                            className="button deleteCat new_btn_add position-static"
                          >
                            <img
                              src={deleteicon}
                              alt="Delete"
                              className="w-auto"
                            />
                          </button>
                        )}
                      {this.state.modalTasks.length - 1 === index && (
                          <button
                            type="button"
                            className="button addCat new_btn_add position-static"
                            onClick={this.addTask}
                          >
                            <img
                              src={pluswIcon}
                              alt="Add"
                              className="w-auto"
                            />
                          </button>
                        )}
                       
                      </div>
                    </div>
                  </div>
                ))}

                {/* Error */}
                {this.state.modalError && (
                  <div className="text-danger text-center mg-b-10">
                    {this.state.modalError}
                  </div>
                )}

                {/* Footer */}
                <div className="row mx-0">
                  <div className="col-md-12 d-flex justify-content-center">
                    {/* Add Task Button */}
                    {/* <button
                      type="button"
                      className="m-0 btn btn-success btn-block "
                      onClick={this.addTask}
                    >
                      Add Task
                    </button> */}
                    <button
                      type="button"
                      className="my-0 mg-l-7 btn btn-outline-light btn-block"
                      onClick={this.closeAddCategoryModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="m-0 btn btn-success btn-block"
                      // style={{ height: "18px", cursor: "pointer" }}
                      onClick={this.submitAddCategory}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </form>
            </Modal.Body>
          </Modal>
          <Modal show={this.state.showBasicModal} centered>
            <Modal.Body className="width_402 p-4 border_radius_14">
              <span className="welcomeClose" onClick={() => this.closeModal()}>
                {global.closee}
              </span>

              <div className="row">
                <div className="col-md-12">
                  <h3 className="text-center mb-3"> Add Note</h3>
                  <p className="note_task_name_box font-weight-bold model_first_p">
                    <label className="form-label">Property Name :</label>
                    {this.state.property_name}
                  </p>
                  <p className="note_task_name_box font-weight-bold model_first_p">
                    <label className="form-label">Task Name :</label>{" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.modifyTaskName(this.state.task_name),
                      }}
                    />
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <label className="form-label mg-b-5">Notes</label>
                  <CustomToolbar />
                  <ReactQuill
                    ref={this.quillRef}
                    theme="snow"
                    name="note"
                    value={this.state.note ?? ""}
                    onChange={this.changeHandlerForNote}
                    modules={modules}
                    formats={global.formats}
                    className="custom_editor_style"
                  />
                  {this.state.showModal && (
                    <LinkModal
                      onClose={this.handleModalClose}
                      onSubmit={this.handleModalSubmit}
                      onRemove={this.handleModalRemove}
                      url={this.state.url}
                      text={this.state.text}
                      isEditing={this.state.isEditing}
                      showModal={this.state.showModal}
                    />
                  )}
                  {this.state.note == undefined ? (
                    <>
                      <div className="text-danger">
                        {this.state.noteMessage != undefined
                          ? this.state.noteMessage
                          : ""}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {/* <input note /> */}

              <div className="note_image_box">
                <div className="">
                  <input
                    onChange={this.imagePreview}
                    className="px-0"
                    type="file"
                    name="file_name"
                    tabIndex="2"
                    multiple
                  />
                  {/* Image Preview */}
                  <ul className="img_view_loop">
                    {(() => {
                      // const dbImages =
                      //   this.state.taskImages?.[this.state.selectedTaskId] ||
                      //   []; // Database images
                      const uploadedImages = this.state.arrAllImages || []; // Newly uploaded images
                      // Merge images & remove duplicates (based on slug)
                      const uniqueImages = [
                        ...uploadedImages,
                        // ...uploadedImages.filter(
                        //   (img) =>
                        //     !dbImages.some((dbImg) => dbImg.slug === img.slug)
                        // ),
                      ];
                      return uniqueImages != undefined &&
                        uniqueImages.length > 0
                        ? uniqueImages.map((record, i) => (
                            <li key={i}>
                              <div className="img_close">
                                <a
                                  href={record?.src || record?.uri || ""}
                                  rel="noreferrer"
                                  target="_blank"
                                >
                                  <img
                                    src={record?.src || record?.uri || ""}
                                    className="brand_list_image"
                                    alt="action image"
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null;
                                      currentTarget.src = placeholderImage;
                                    }}
                                  />
                                </a>
                                <button
                                  type="button"
                                  className="btn btn-danger btn_remove"
                                  onClick={() => this.deleteImage(i)}
                                >
                                  <span className="fa fa-times"></span>
                                </button>
                              </div>
                            </li>
                          ))
                        : "";
                    })()}
                  </ul>
                </div>
                {/* Image Preview end*/}
              </div>
              {error && <p style={{ color: "red" }}>{error}</p>}

              <div className="row">
                <div className="col-md-12">
                  <div className="qes_ans_box crete_mro_checkbox">
                    <label className="check_cust">
                      <input
                        type="checkbox"
                        defaultChecked={this.state.checked}
                        name="is_exclude"
                        onChange={(e) => this.handleCheckboxChange(e)}
                        value={this.state.is_action_with_note}
                      />
                      <span className="checkmark"></span>Create Action Item
                    </label>
                  </div>
                </div>
              </div>

              <div
                className={
                  "create_mro_field_section" +
                  (this.state.checked === true ? "d-block" : "")
                }
              >
                <div className="row">
                  <div className="col-md-12 mg-b-15">
                    <label className="form-label mg-b-5">Priority</label>
                    <Select
                      className="multiselect new_drop"
                      menuPlacement="auto"
                      value={this.state.selectedPriorityType}
                      options={this.state.priorityType}
                      isSearchable={true}
                      onChange={(value) => this.handleChangePriority(value)}
                      defaultValue={this.state.selectedPriorityType}
                      autoComplete="off"
                      getOptionValue={(option) => `${option.label}`}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary75: "#808080",
                          primary50: "#808080",
                          primary25: "#808080",
                        },
                      })}
                    />
                    {this.state.priority_type == undefined ? (
                      <>
                        <div className="text-danger">
                          {this.state.priority_type_error}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-md-12 mg-b-15">
                    <label className="form-label mg-b-5"> Assign To</label>
                    <Select
                      className="multiselect new_drop"
                      menuPlacement="auto"
                      value={this.state.selectedUserList}
                      options={this.state.userList}
                      onChange={(value) => this.handleChangeUserList(value)}
                      defaultValue={this.state.selectedUserList}
                      autoComplete="off"
                      getOptionValue={(option) => `${option.label}`}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary75: "#808080",
                          primary50: "#808080",
                          primary25: "#808080",
                        },
                      })}
                    />
                    {this.state.user_slug == undefined ? (
                      <>
                        <div className="text-danger">
                          {this.state.user_slug_error}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-md-12 mg-b-15">
                    <label className="form-label mg-b-5">Due Date</label>
                    <DatePicker
                      className="form-control max_width_100"
                      showMonthDropdown
                      showYearDropdown
                      // scrollableYearDropdown
                      autoComplete="off"
                      yearDropdownItemNumber={global.yearDropdownItemNumber}
                      name="due_date"
                      placeholderText="mm-dd-yyyy"
                      dateFormat="dd MMM yyyy"
                      selected={this.state.due_date}
                      onChange={(data) =>
                        this.handleDueDate({
                          target: {
                            type: "date",
                            name: "due_date",
                            value: data,
                          },
                        })
                      }
                      minDate={Moment().toDate()}
                    />
                    {this.state.due_date == undefined ? (
                      <>
                        <div className="text-danger">
                          {this.state.due_date_error}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex cnt_center row mt-3">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closeModal()}
                  disabled={this.state.isLoading}
                >
                  Close
                </button>

                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block btn-thene-modal"
                  onClick={this.submitModalforNote}
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? global.loader : "Submit"}
                </button>
                {this.state.note != undefined ||
                (this.state.arrAllImages != undefined &&
                  this.state.arrAllImages.length > 0) ? (
                  <button
                    type="button"
                    className="m-0 btn btn-danger"
                    onClick={() => this.deleteNote()}
                    disabled={this.state.isLoading}
                  >
                    Delete
                  </button>
                ) : (
                  ""
                )}
              </div>
            </Modal.Body>
          </Modal>
          {/*add task modal*/}
          <Modal className="per_checklist_modal" dialogClassName="per_checklist_modal_dialog" show={this.state.showAddTaskModal} centered size="lg">
            <Modal.Body className="width_402 p-4 border_radius_14">
              <form onSubmit={(e) => e.preventDefault()}>
                {/* Header */}
                {/* <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-30 pd-r-20">
                  <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-0 pd-b-1 pd-r-0 pl-0">
                    <div className="az-content-label titleLable pl-0"> */}
                      <h3 className="text-center">Add Task</h3>
                    {/* </div> */}
                  {/* </div>
                </div> */}

                {/* CATEGORY */}
                {/* <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-0 w-100"> */}
                  <div className="col-md-12 col-lg-12 mg-b-15">
                    <label className="form-label text-left mg-b-5">
                      Category
                    </label>
                    <input
                      type="text"
                      className="form-control max_width_100"
                      value={this.state.modalCategory}
                      onChange={(e) =>
                        this.setState({
                          modalCategory: e.target.value,
                          categoryError: "", // clear error while typing
                        })
                      }
                      disabled
                    />
                    {this.state.categoryError && (
                      <div className="text-danger mt-1">
                        {this.state.categoryError}
                      </div>
                    )}
                  </div>
                {/* </div> */}

                {/* TASKS */}
                {this.state.modalTasks.map((task, index) => (
                  <div key={index} className="mb-3">
                    {/* Task Label + Remove Button */}
                    <div
                      className="col-md-5 col-lg-8 mg-t-5 pd-l-70"
                      style={{ gap: "3px" }}
                    >
                      <label
                        className="form-label mb-0"
                        style={{ marginBottom: 0 }}
                      >
                        Task{" "}
                      </label>

                      {/* {this.state.modalTasks.length > 1 && (
                        <button
                          type="button"
                          onClick={() => this.removeTask(index)}
                          style={{
                            padding: "2px",
                            border: "none",
                            background: "transparent",
                          }}
                        >
                          <img
                            src={deleteicon}
                            alt="Delete"
                            style={{
                              width: "16px",
                              height: "16px",
                              cursor: "pointer",
                            }}
                          />
                        </button>
                      )} */}
                    </div>

                    {/* Quill Editor */}
                    <div className="row mx-0">
                      <div className="col-md-11 col-lg-11 mg-t-5 pd-l-70">
                        <div id={`toolbar-${index}`}>
                          <button className="ql-bold"></button>
                          <button className="ql-italic"></button>
                          <button className="ql-underline"></button>
                          <button className="ql-link"></button>
                        </div>

                        <ReactQuill
                          theme="snow"
                          value={task.text || ""}
                          onChange={(val) => this.handleTaskChange(val, index)}
                          modules={{
                            toolbar: { container: `#toolbar-${index}` },
                          }}
                          formats={global.formats}
                          className="custom_editor_style"
                        />
                      </div>
                      <div className="col-md-1 col-lg-1">
                        {this.state.modalTasks.length > 1 && (
                        <button
                          type="button"
                          onClick={() => this.removeTask(index)}
                          style={{
                            padding: "2px",
                            border: "none",
                            background: "transparent",
                          }}
                        >
                          <img
                            src={deleteicon}
                            alt="Delete"
                            style={{
                              width: "16px",
                              height: "16px",
                              cursor: "pointer",
                            }}
                          />
                        </button>
                      )}
                      </div>
                    </div>
                  </div>
                ))}

                {/* Error */}
                {this.state.modalError && (
                  <div className="text-danger text-center mg-b-10">
                    {this.state.modalError}
                  </div>
                )}

                {/* Footer */}
                <div className="row m-0 pd-b-20 pd-l-70 pd-r-30">
                  <div className="col-md-12 d-flex justify-content-center">
                    {/* Add Task Button */}

                    <button
                      type="button"
                      className="m-0 btn btn-outline-light btn-block"
                      onClick={this.closeAddTaskModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="m-0 btn btn-success btn-block"
                      onClick={this.submitAddTask}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </form>
            </Modal.Body>
          </Modal>
          <Modal show={this.state.deletetaskModal} centered>
                    <Modal.Body className="width_402 p-4 border_radius_14">
                      <div className="text-center">
                        {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
                        <h3>Delete Task?</h3>
                        <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                          Do you really want to delete this Task? This process
                          cannot be undone.
                        </p>
                        <div className="d-flex cnt_center mt-3 row">
                          <button
                            type="button"
                            className=" m-0 btn btn-outline-light btn-block"
                            onClick={() => this.closedeletetaskModal()}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className=" m-0 btn btn btn-danger btn-block"
                            onClick={() => this.deletetask(this.state.deleteTaskSlug)}
                            disabled={this.state.isDelete ? true : false}
                          >
                            {this.state.isDelete ? global.loader : "Delete"}
                          </button>
                        </div>
                      </div>
                  </Modal.Body>
                  </Modal>
          <Modal show={this.state.deleteCategoryModal} centered>
            <Modal.Body className="width_402 p-4 border_radius_14">
              <div className="text-center">
                <h3>Delete Category?</h3>
                <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                  Do you really want to delete{" "}
                  <strong>{this.state.deleteCategoryName}</strong>? All tasks in
                  this category will be removed.
                </p>
                <div className="d-flex cnt_center mt-3 row">
                  <button
                    type="button"
                    className="m-0 btn btn-outline-light btn-block"
                    onClick={this.closeDeleteCategoryModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="m-0 btn btn-danger btn-block"
                    onClick={this.deleteCategory}
                    disabled={this.state.isDeleteCategory}
                  >
                    {this.state.isDeleteCategory ? global.loader : "Delete"}
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  };

  thirdComponent = () => {
    return (
      <div>
        <div className="row row-xs">
          <div className="col-md-12 d-none">
            <div className="az-content-label titleLable pl-0">Review</div>
          </div>

      

          <div className="col-md-12">
            {this.state.category != undefined
              ? this.state.category
                  .filter(
                    (element) =>
                      Array.isArray(element.tasks) && element.tasks.length > 0
                  )
                  .map((element, index) => (
                  <span key={"rev" + index}>
                    {element.tasks
                      ? element.tasks.map((el, indexes) => (
                          <>
                            <span key={"revs" + indexes}>
                              {el.is_action_with_note === 1 ? (
                                <>
                                  <p className="titleLable pl-4 insp_cat_list_box mb-1">
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: this.modifyTaskName(
                                          el.task_name
                                        ),
                                      }}
                                    />
                                  </p>
                                </>
                              ) : (
                                ""
                              )}
                            </span>
                          </>
                        ))
                      : ""}
                  </span>
                ))
              : ""}
          </div>
        </div>
        <div className="row row-xs">
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5">Completed On</label>
            <DatePicker
              className="form-control max_width_100"
              showMonthDropdown
              showYearDropdown
              // scrollableYearDropdown
              autoComplete="off"
              yearDropdownItemNumber={global.yearDropdownItemNumber}
              name="out_time"
              placeholderText="mm-dd-yyyy"
              dateFormat="dd MMM yyyy | hh:mm a"
              selected={this.state.out_time}
              onChange={(data) =>
                this.changeHandler({
                  target: {
                    type: "date",
                    name: "out_time",
                    value: data,
                  },
                })
              }
            />
            {this.state.errors.out_time ? (
              <div className="text-danger">{this.state.errors.out_time}</div>
            ) : (
              this.validator.message(
                "Out Time",
                this.state.out_time,
                "required",
                { className: "text-danger" }
              )
            )}
          </div>
          <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
            <label className="form-label mg-b-5"> Status</label>
            <Select
              name="status"
              className="multiselect new_drop"
              menuPlacement="auto"
              value={this.state.selectedStatus}
              options={
                Array.isArray(this.state.status) ? this.state.status : []
              }
              isSearchable={true}
              onChange={(value) => this.handleChangeStatus(value)}
              defaultValue={
                Array.isArray(this.state.status) && this.state.status.length > 0
                  ? this.state.status[0]
                  : null
              }
              autoComplete="off"
              getOptionValue={(option) => `${option?.label ?? ""}`}
              styles={customStyles}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary75: "#808080",
                  primary50: "#808080",
                  primary25: "#808080",
                },
              })}
            />
            {this.state.errors.status ? (
              <div className="text-danger">{this.state.errors.status}</div>
            ) : (
              this.validator.message("Status", this.state.status, "required", {
                className: "text-danger",
              })
            )}
          </div>
        </div>
      </div>
    );
  };
  modifyTaskName(taskName) {
    // Create a temporary element to manipulate the HTML string
    const tempElement = document.createElement("div");
    tempElement.innerHTML = taskName;

    // Find all links in the element
    const links = tempElement.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });

    // Return the modified HTML
    return tempElement.innerHTML;
  }

  handleChangeStatus(value) {
    let status = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        status.push(item.value);
      });
    }
    this.setState({
      selectedStatus: value,
      status_id: value.value,
    });
    this.setState({ confirm_back: 1 });
  }

  checkHocAuditexist = async (e) => {
     
    let inputData = {
      property_slug: this.state.property_slug,
      user_slug: global.userData.slug,
      status_id: 1,
      out_time: null,

    };
  
      try {
        let res = await AuditService.existAuditHoc(inputData);
       
          if (res.data.slug==null) {
            // create audit only if it doesn't exist
        
            await this.startAudit(e);
          } else {
            
              // Default case: show resume confirmation modal
              this.setState({
                showConfirmModel: true,
                loading: false,
                isSubmit: false,
                audit_slug: res.data.slug,
              });
              return { exists: true, resumed: false };
            
          
        } 
      } catch (error) {
        console.error("Error Visit exist:", error);
        this.setState({
          loading: false,
          isSubmit: false,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error!",
          alertModalMessage: "An error occurred while  checking",
        });
        return null;
      }
    };
  
  handleNext = async (e) => {
    const { steps, activeStep } = this.state;
    const index = steps.findIndex((x) => x.key === activeStep.key);
  

    // ---------- FIRST STEP ----------
    if (activeStep.key === "firstStep") {
      // Only start audit if required fields exist
      if (this.state.property_slug && this.state.in_time && this.state.title) {
           if (!this.state.audit_slug) 
            {
              await this.checkHocAuditexist(e);
              
             
            }
          else
            {
            this.startAudit(e);

            
            } 
          // <-- create audit here
           this.setState({
          showAlertModal: false,
          alertModalType: "",
          alertModalTitle: "",
          alertModalMessage: "",
          priority_type_error:"",
        });
        return; // stop further step logic; navigation handled inside startAudit
      } 
    else {
        // Optionally show validation errors
        this.validator.showMessages();

        return;
      }
    }

    // ---------- SECOND STEP & OTHERS ----------

    if (this.state.activeStep.key === "secondStep") {
      /* Out time set */
      this.setState({
        showAlertModal: false,
        alertModalType: "",
        alertModalTitle: "",
        alertModalMessage: "",
      });
      var outTime = Moment(new Date()).toDate("dd-MM-YYYY | hh:mm A");
      this.setState({ out_time: outTime });
      /* isdone class update on press continiue button // result color change tab */

      const updatedSteps = steps.map((x) => {
        if (x.key === activeStep.key) x.isDone = true;
        return x;
      });
      this.setState({ steps: updatedSteps, activeStep: steps[index + 1] });
      // }
    }
    this.customValidate();

    // ---------- FINAL STEP ----------
    if (steps[steps.length - 1].key === activeStep.key) {
      this.stepThreeSave(); // save on final step
      return;
    }

    this.customValidate();
  };
  handleBack = () => {
    const { steps, activeStep } = this.state;
    const index = steps.findIndex((x) => x.key === activeStep.key);
    if (index === 0) return;
    steps[index].isDone = false;
    this.setState({ backIndex: index });
    this.setState({ steps, activeStep: steps[index - 1] });
  };
  checkInspectionAvailableOnChecklistInLocal = async () => {
    const localInsp = localStorage.getItem("localInsp") || "";
    var newKey = `${global.userData.slug}/${this.state.property_slug}/${this.state.checklist_slug}`;
    this.setState({
      localInsp: localInsp ? JSON.parse(localInsp) : "",
      newKey: newKey,
    });

    /* Find the key available in the existing array or not   */
    var match = false;
    if (localInsp.includes(newKey)) {
      match = true;
    }

    return match;
  };

  localDataStorage = async (category) => {
    if (category !== undefined && category !== null) {
      const localInsp = localStorage.getItem("localInsp") || "";
      if (localInsp != "" && localInsp != undefined) {
        let finalLocalArr = [];

        /* conver into the object */
        var localInspObj = JSON.parse(localInsp);

        /* Check the uniq key in the array */
        const newKey = `${global.userData.slug}/${this.state.property_slug}/${this.state.checklist_slug}`;

        // find the index of unique key
        const index = localInspObj
          ? localInspObj.findIndex((x) => x.uniqueKey === newKey)
          : -1;

        // Key available in the array,  index > -1  in the existing array
        if (index !== -1) {
          const newArr = [
            {
              property_slug: this.state.property_slug,
              checklist_slug: this.state.checklist_slug,
              property_inspection_perform:
                this.state.property_inspection_perform,
              checklist_name_heading: this.state.checklist_name_heading,
              zone_name_heading: this.state.zone_name_heading,
              category: category,
              uniqueKey: newKey,
            },
          ];

          /*  remove the index from the existing array*/
          const arrAfterRemoveKey = localInspObj.filter(
            (item) => item.uniqueKey !== newKey
          );

          /* Update the new object in the existing array */
          let finalLocalArr = [...arrAfterRemoveKey, ...newArr];

          /* store new array in the localstorage */
          await localStorage.setItem(
            "localInsp",
            JSON.stringify(finalLocalArr)
          );
        }

        /* Key not avaialble in the array, Index == -1 are  find in the existing array */
        if (index === -1) {
          const newArr = [
            {
              property_slug: this.state.property_slug,
              checklist_slug: this.state.checklist_slug,
              property_inspection_perform:
                this.state.property_inspection_perform,
              checklist_name_heading: this.state.checklist_name_heading,
              zone_name_heading: this.state.zone_name_heading,
              category: category,
              uniqueKey: newKey,
            },
          ];

          /* if localInspObj get null then remove the key */
          if (localInspObj == null) {
            localStorage.removeItem("localInsp");
            /* Add new object in the existing array  =========== No need to remove the Index */
            finalLocalArr = newArr;
          } else {
            /* Add new object in the existing array  =========== No need to remove the Index */
            finalLocalArr = [...localInspObj, ...newArr];
          }

          /* store new array in the localstorage */
          await localStorage.setItem(
            "localInsp",
            JSON.stringify(finalLocalArr)
          );
        }
      } else {
        /* Create first object  */
        const newKey = `${global.userData.slug}/${this.state.property_slug}/${this.state.checklist_slug}`;
        const newData = [
          {
            property_slug: this.state.property_slug,
            checklist_slug: this.state.checklist_slug,
            property_inspection_perform: this.state.property_inspection_perform,
            checklist_name_heading: this.state.checklist_name_heading,
            zone_name_heading: this.state.zone_name_heading,
            category: category,
            uniqueKey: newKey,
          },
        ];

        // Set the final array to the local storage key
        await localStorage.setItem("localInsp", JSON.stringify(newData));
      }
    }
  };
  render() {
    const { steps, activeStep } = this.state;
    return (
      <>
        <main>
          <div className="container-fluid">
            <div className="row row-xs">
              <div className="col-md-12">
                <div className="dashbaord-pageHeadertitle heading_alignment">
                  <h3 className="flex-column">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <h3>Ad-Hoc  Property Visits Checklist</h3>
                      {this.state.isResume === true ? (
                      <Link
                        to={`/audits/${this.state.audit_slug}`}
                      >
                        <img src={back} alt="" />
                        Back
                      </Link>
                    ) : (
                      <Link
                        to={`/audit-templates`}
                      >
                        <img src={back} alt="" />
                        Back
                      </Link>
                    )}
                    </div>
                    <span>{this.state.property_name}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-md-12 pl-0 pr-0">
              <Alerts
                show={this.state.showAlertModal}
                type={this.state.alertModalType}
                title={this.state.alertModalTitle}
                message={this.state.alertModalMessage}
                onClose={() => this.setState({ showAlertModal: false })}
              />
            </div>
          </div>
          <div className="container-fluid">
            <div className="inspection_perform_section">
              <div className="row row-xs mg-t-20 justify-content-center">
                <div className="col-md-12 col-xl-12">
                  <div className="box dashboardRightcard p-0">
                    <div className="steps">
                      <ul className="nav">
                        {steps.map((step, i) => {
                          return (
                            <li
                              key={i}
                              className={`${
                                activeStep.key === step.key ? "active" : ""
                              } ${step.isDone ? "done" : ""}`}
                            >
                              <div>
                                <span>{step.label}</span>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                    <div className="step-component pd-l-70 pd-r-70">
                      <form
                        id="insp_form"
                        method="post"
                        encType="multipart/form-data"
                      >
                        {activeStep.component()}
                        <div className="col-md-12">
                          <div className="btn-component mg-t-5 mg-md-t-0">
                            <input
                              type="button"
                              value="Back"
                              onClick={this.handleBack}
                              disabled={steps[0].key === activeStep.key}
                            />
                            <button
                              className="gf-btn-lg-stroke mg-l-2"
                              type="button"
                              onClick={this.handleNext}
                              disabled={this.state.isSubmit ? true : false}
                            >
                              {this.state.isSubmit
                                ? global.loader
                                : activeStep.key == "finalStep"
                                ? "Submit"
                                : "Continue"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    );
  }
}

export default App;
